package pl.nickers.match3.ecs

import pl.nickers.match3.SoundEvent

internal class LaserResolveSystem(
    private val pieceSet: PieceSet = PieceSetLoader.default(),
) : BaseSystem() {
    private lateinit var posMapper: ComponentMapper<GridPositionComponent>
    private lateinit var activatedLaserMapper: ComponentMapper<ActivatedLaserComponent>

    override fun initialize() {
        posMapper = world.mapper()
        activatedLaserMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.RESOLVE || board.currentSubphase != ResolveSubphase.LASER) return
        val firingLasers = world.getEntitiesForAspect(Aspect.all(ActivatedLaserComponent::class)).toList()
        if (firingLasers.isEmpty()) return
        fireLasers(firingLasers, board)
        board.didWork = true
    }

    private fun fireLasers(firingLasers: List<Int>, board: BoardStateComponent) {
        world.enqueueAudioEvent(SoundEvent.LASER_FIRE)
        val sources = firingLasers.toSet()
        val consumedMapper: ComponentMapper<ConsumedComponent> = world.mapper()

        val inRange = mutableSetOf<Int>()
        val forcedConsumed = mutableSetOf<Int>()
        for (laserEntity in firingLasers) {
            val activation = activatedLaserMapper[laserEntity]
            activatedLaserMapper.remove(laserEntity)
            val pos = posMapper[laserEntity] ?: continue
            val defaultDir = world.laserDirectionOf(laserEntity, pieceSet) ?: continue
            val directions = activation?.directions ?: setOf(defaultDir)
            forcedConsumed += activation?.forcedConsumedEntities.orEmpty()
            directions.forEach { direction ->
                inRange += collectLaserTargets(world, board.width, board.height, pos, direction)
            }
        }

        sources.forEach { consumedMapper.set(it, ConsumedComponent()) }
        forcedConsumed.forEach { consumedMapper.set(it, ConsumedComponent()) }

        val toRemove = resolveAreaOfEffect(
            world = world,
            targets = inRange + forcedConsumed,
            pieceSet = pieceSet,
        )
        world.scoreDeleteAndCheckGoals(toRemove, board)
    }
}
